// @flow
import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMRestClient from 'lib/SMRestClient';
import SMUserResource from 'resources/SMUserResource';
import SMHistoryHelper from 'components/helpers/SMHistoryHelper';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMPointCodeResource from 'resources/SMPointCodeResource';

type Props = {
  action: string,
  user: Object,
  selectedRowIndex: number,
  pointHistories: Object[],
  currentPage: number,
  perPage: number,
  totalCount: number,
  linkString: string,
};

type State = {
  pointHistories: Object[],
  points: Object[],
  currentPage: number,
  selectedRowIndex: number,
  perPage: number,
  totalCount: number,
  links: string,
  isPointCodePopupViewOpen: boolean,
  pointCode: string,
  pointCodeErrorMessage: string,
  pointCodeSuccessMessage: string,
  user: Object
}

class SMUPointView extends SMDashboardBaseView {
  state: State;
  constructor(props: Props) {
    super(props);
    this.state = {
      pointHistories: this.props.pointHistories || [],
      points: this.props.points || [],
      currentPage: this.props.currentPage,
      selectedRowIndex: this.props.selectedRowIndex,
      perPage: this.props.perPage,
      totalCount: this.props.totalCount,
      links: SMRestClient.parseLinkString(this.props.linkString),
      isPointCodePopupViewOpen: false,
      pointCode: '',
      pointCodeErrorMessage: '',
      pointCodeSuccessMessage: '',
      user: this.props.user,
    };
  }

  componentDidMount() {
    this.applyResponsive();
  }

  pageDidSelect(page: number, e: Object) {
    e.preventDefault();
    this.requestResource(page, this.state.selectedRowIndex);
  }

  tabDidSelect(e: Object) {
    e.preventDefault();
    const tabIndex = e.currentTarget.dataset.tabindex;
    this.setState({
      selectedRowIndex: tabIndex
    });
    this.requestResource(1, tabIndex);
    let path = null;
    switch (tabIndex) {
      case "1":
        path = Routes.dashboard_points_pending_point_histories_path();
        break;
      case "2":
        path = Routes.dashboard_points_expiring_points_path();
        break;
      default:
        path = Routes.dashboard_points_available_point_histories_path();
        break;
    }
    SMHistoryHelper.replaceState(path, this.state);
  }

  openPointCodePopup() {
    this.setState({isPointCodePopupViewOpen: true});
  }

  closePointCodePopup() {
    this.setState({
      isPointCodePopupViewOpen: false,
      pointCode: '',
      pointCodeErrorMessage: '',
      pointCodeSuccessMessage: '',
    });
  }

  requestResource(page: number, selectedRowIndex: number) {
    let queries = {};
    queries["page"] = page;
    ($(this.refs.detailList): any).startLoading();
    if (selectedRowIndex < 2) {
      if (selectedRowIndex == 0) {
        queries["status"] = "available";
      } else {
        queries["status"] = "pending";
      }
      SMUserResource.getPointHistories(this.state.user, queries, (data, errors, xhr)=>{
        ($(this.refs.detailList): any).stopLoading();
        this.setState({
          pointHistories: data,
          currentPage: page,
          totalCount: xhr.getResponseHeader("x-list-total-count"),
          links: SMRestClient.getLinks(xhr),
        });
      });
    } else {
      SMUserResource.getPoints(this.state.user, queries, (data, errors, xhr)=>{
        ($(this.refs.detailList): any).stopLoading();
        this.setState({
          points: data,
          currentPage: page,
          totalCount: xhr.getResponseHeader("x-list-total-count"),
          links: SMRestClient.getLinks(xhr),
        });
      });
    }
  }

  renderPointSummary() {
    const point_balance = this.state.user.point_balance;
    return (
      <div className="clear dashboard-point__head">
        <div className="dashboard-point__sum">
          <div className="dashboard-point__sum-now">
            <h2 className="dashboard-point__sum-now-title">所持ポイント</h2>
            <p className="dashboard-point__sum-now-have">{point_balance.available_amount_text}<span className="dashboard-point__unit">ポイント</span></p>
          </div>
          <div className="dashboard-point__sum-will">
            <h3 className="dashboard-point__sum-will-title">獲得予定<br className="sm-hide" />ポイント</h3>
            <p className="dashboard-point__sum-will-have">{point_balance.pending_amount_text}<span className="dashboard-point__unit">ポイント</span></p>
            <h3 className="dashboard-point__sum-will-title ml20">1ヶ月以内に期限<br className="sm-hide" />を迎えるポイント</h3>
            <p className="dashboard-point__sum-will-have">{point_balance.expiring_amount_text}<span className="dashboard-point__unit">ポイント</span></p>
          </div>
        </div>
        <p className="dashboard-point__referrallink">
          <a href={Routes.referrals_path()} target="_blank" className="top-more__area-link">招待キャンペーンで2,000ポイントGET</a>
        </p>
      </div>
    );
  }

  renderPointHistories() {
    const pointHistories = this.state.pointHistories;

    const rows = [
      <tr key="title" className="dashboard-point__detail-heading">
        <th className="dashboard-point__detail-heading-date">日付</th>
        <th className="dashboard-point__detail-heading-overview">概要</th>
        <th className="dashboard-point__detail-heading-status">ステータス</th>
        <th className="dashboard-point__detail-heading-point">ポイント</th>
      </tr>
    ];

    pointHistories.forEach((pointHistory)=>{
      const createdAt = pointHistory.created_at;
      const year = SMFormatHelper.formatDate(createdAt, "Y");
      const month = SMFormatHelper.formatDate(createdAt, "M");
      const day = SMFormatHelper.formatDate(createdAt, "D");
      const minusClassName = pointHistory.amount < 0 ? "dashboard-point__detail-minus" : null;

      let statusRow = null;
      if (pointHistory.history_type_text.includes(' ')) {
        const historyTypeTexts = pointHistory.history_type_text.split(' ');
        statusRow = <th className={`dashboard-point__detail-status ${minusClassName}`}>{historyTypeTexts[0]}<br />{historyTypeTexts[1]}</th>;
      } else {
        statusRow = <th className={`dashboard-point__detail-status ${minusClassName}`}>{pointHistory.history_type_text}</th>;
      }

      rows.push(
        <tr key={`pointHistory_${pointHistory.id}`} className="dashboard-point__detail-content">
          <th className="dashboard-point__detail-date">{year}/<br className="pc-hide__sm-show" />{month}/{day}</th>
          <th className="dashboard-point__detail-overview"><span className="dashboard-point__detail-overview-cut">{pointHistory.title}</span></th>
          {statusRow}
          <th className={`dashboard-point__detail-point ${minusClassName}`}>{pointHistory.amount_text}</th>
        </tr>
      );
    });

    return this.renderDetails(rows);
  }

  renderPointDetails() {
    const points = this.state.points;

    const rows = [
      <tr key="title" className="dashboard-point__detail-heading">
        <th className="dashboard-point__detail-date-will">有効期限</th>
        <th className="dashboard-point__detail-heading-overview">概要</th>
        <th className="dashboard-point__detail-heading-point">ポイント</th>
      </tr>
    ];

    points.forEach((point)=>{
      const expiresAt = point.expires_at;
      const year = SMFormatHelper.formatDate(expiresAt, "Y");
      const month = SMFormatHelper.formatDate(expiresAt, "M");
      const day = SMFormatHelper.formatDate(expiresAt, "D");

      rows.push(
        <tr key={`point_${point.id}`} className="dashboard-point__detail-content">
          <th className="dashboard-point__detail-date">{year}/<br className="pc-hide__sm-show" />{month}/{day}</th>
          <th className="dashboard-point__detail-overview"><span className="dashboard-point__detail-overview-cut">{point.title}</span></th>
          <th className="dashboard-point__detail-point">{point.amount_text}</th>
        </tr>
      );
    });

    return this.renderDetails(rows);
  }

  renderDetails(rows: Object[]) {
    return(
      <div className="dashboard-point__detail-history">
        <table className="dashboard-point__detail-table">
          <tbody>
            {rows}
          </tbody>
        </table>
        <SMSearchPagerView
          delegate={this}
          perPage={this.state.perPage}
          totalCount={this.state.totalCount}
          currentPage={this.state.currentPage}
          links={this.state.links}
        />
      </div>
    );
  }

  renderPointCodePopupView() {
    if (this.state.isPointCodePopupViewOpen) {
      return (
        <div ref="form" className="maincol-lightbox" style={{position: "absolute"}}>
          <div className="form-casette lightbox-point">
            <h1 className="dashboard-title mb10">ポイントコード入力</h1>
            <p className="dashboard-title__supplement lightbox-point__supplement">
              お持ちのポイントコードを入力することで、ポイントを獲得できます。
            </p>
            <div className="lightbox-point__form">
              <p className="lightbox-point__form-box">
                <input type="text" className="form-text w260" placeholder="ポイントコードを入力"
                  ref='inputPointCode' onChange={this.pointCodeDidChange.bind(this)} value={this.state.pointCode} />
              </p>
              <input className="button-blue lightbox-point__form-button" value="適用"
                onClick={this.pointCodeApplyButtonDidClick.bind(this)} />
              {this.renderPointCodeErrorMessage()}
              {this.renderPointCodeSuccessMessage()}
            </div>
            <a href="#" className="form-casette__close" onClick={this.closePointCodePopup.bind(this)}><i className="fa fa-times"></i></a>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  pointCodeDidChange(e) {
    this.setState({
      pointCode: e.currentTarget.value
    });
  }

  renderPointCodeSuccessMessage() {
    if (this.state.pointCodeSuccessMessage) {
      return (
        <p className="popup-form__completed">
          <i className="fa fa-check-circle"></i>
          {this.state.pointCodeSuccessMessage}
        </p>
      );
    }
    return null;
  }

  renderPointCodeErrorMessage() {
    if (this.state.pointCodeErrorMessage) {
      return <p className="popup-form__required"><i className="fa fa-exclamation-circle"></i>{this.state.pointCodeErrorMessage}</p>;
    }
    return null;
  }

  pointCodeApplyButtonDidClick(e) {
    this.setState({ pointCode: this.refs.inputPointCode.value });
    const requestBody = {
      point_code: this.refs.inputPointCode.value
    };
    SMPointCodeResource.applyPointCode(requestBody, this.state.user.id, (appliedPointCode, error, xhr)=>{
      if (xhr.status != 200 && xhr.status != 201) {
        this.setState({ pointCodeErrorMessage: xhr.responseJSON.message , pointCodeSuccessMessage: '' });
      } else {
        const message = `${xhr.responseJSON.point_code_amount_text}ポイント獲得しました。`;
        this.setState({ pointCodeErrorMessage: '', pointCodeSuccessMessage: message });

        // ユーザーデータ再取得
        SMUserResource.getUser(this.state.user.id, (data, errors, xhr)=>{
          this.setState({
            user: xhr.responseJSON
          });
        });

        // ポイント詳細の再取得
        this.requestResource(1, this.state.selectedRowIndex);
      }
    });
  }

  render() {
    const rowIndex = this.state.selectedRowIndex;
    const currentClass = "dashboard-point__detail-tab-current";

    return (
      <div className="container dashboard-point">
        <h1 className="dashboard-title dashboard-point__title">ポイント</h1>
        <p><a className="button-blue dashboard-point__code" href="#" onClick={this.openPointCodePopup.bind(this)}>ポイントコード入力</a></p>
        {this.renderPointSummary()}
        <div ref="detailList" className="dashboard-point__detail">
          <ul className="row dashboard-point__detail-tab">
            <a data-tabIndex="0" href="#" onClick={this.tabDidSelect.bind(this)}><li className={`col-xs-4 dashboard-point__detail-tab-content ${rowIndex == 0 ? currentClass : ""}`}>所持ポイント</li></a>
            <a data-tabIndex="1" href="#" onClick={this.tabDidSelect.bind(this)}><li className={`col-xs-4 dashboard-point__detail-tab-content ${rowIndex == 1 ? currentClass : ""}`}>獲得予定ポイント</li></a>
            <a data-tabIndex="2" href="#" onClick={this.tabDidSelect.bind(this)}><li className={`col-xs-4 dashboard-point__detail-tab-content ${rowIndex == 2 ? currentClass : ""}`}>有効期限</li></a>
          </ul>
          {rowIndex == 2 ? this.renderPointDetails() : this.renderPointHistories()}
        </div>
        {this.renderPointCodePopupView()}
      </div>
    );
  }
}
export default SMUPointView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/points/SMUPointView.jsx